import { Box as MaterialBox } from '@mui/material';

function Box({ children, ...props }) {
  return <MaterialBox {...props}>{children}</MaterialBox>;
}

export default Box;
